/**
 * @module components/canvas/Minimap
 * @summary Overview minimap overlay (engine paints #minimap-canvas).
 * @ported-from JCC PFD Engineering Tool v1.1.html lines 559-562 + 4091-4099.
 */
import { useState } from 'react';
import { engine } from '../../engine/CanvasEngine';

export function Minimap() {
  const [collapsed, setCollapsed] = useState(false);

  const toggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    const c = engine.toggleMinimap();
    setCollapsed(c);
  };

  return (
    <div id="minimap-wrap" className={collapsed ? 'collapsed' : ''}>
      <div id="minimap-header">
        <span>Overview</span>
        <span id="mm-toggle" onClick={toggle} role="button" aria-label="Toggle minimap">
          {collapsed ? '+' : '−'}
        </span>
      </div>
      {/* The engine draws into this canvas each frame (queried by id). */}
      <canvas id="minimap-canvas" width={180} height={108} />
    </div>
  );
}
